// 导入封装好的网络请求类工具
import Request from './request';
import data from './baseUrl';


// 封装各种接口请求
const baserurlUser = data.baseurl + '/sjpt/tourism' //用户相关
const baserurlMall = data.baseurl + '/sjpt/reservation' //商城相关
const baserurlMall1 = data.baseurl1 + '/sjpt/reservation' //商城相关
const baserurlWeather = 'http://wthrcdn.etouch.cn' //天气接口  /weather_mini

// export const 接口名 = () => Request.get('/路由',参数对象);

export const getMallData = async (url, data) => await Request.get(baserurlMall + url, data);
export const getMallData1 = async (url, data) => await Request.get(baserurlMall1 + url, data);

export const postMallData = async (url, data) => await Request.post(baserurlMall + url, data);
export const postMallData1 = async (url, data) => await Request.post(baserurlMall1 + url, data);

export const deleteMallData = async (url, data) => await Request.delete(baserurlMall + url, data);

export const getUserData = async (url, data) => await Request.get(baserurlUser + url, data);

export const postUserData = async (url, data) => await Request.post(baserurlUser + url, data);

export const getWeatherData = async (url, data) => await Request.get(baserurlWeather + url, data); //天气接口



// WEBPACK FOOTER //
// ./src/assets/api/index.js